export const ApiCall = async (api, body, method, type) => {
  let requestbody;
  if (type === 'file') {
    requestbody = {
      method: method,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    try {
      const res = await fetch(api, requestbody);
      const blob = await res.blob();
      // Try to get filename from Content-Disposition header
      let filename = 'download.zip';
      const disposition = res.headers.get('Content-Disposition');
      if (disposition && disposition.indexOf('filename=') !== -1) {
        filename = disposition.split('filename=')[1].replace(/['"]/g, '');
      }
      return { blob, filename };
    } catch (error) {
      return error;
    }
  }
  if (type !== "multipart") {
    requestbody =
      body !== null && body !== undefined && body !== ""
        ? {
            method: method,

            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
              
            },
            body: JSON.stringify(body),
          }
        : {
            method: method,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            
            },
          };
    
  } else {
    requestbody =
      body !== undefined && body !== ""
        ? {
            method: method,
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: body,
          }
        : {
            method: method,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          };
  }
  try {
    const res = await fetch(api, requestbody);
    if (res.status === 401 && api.includes("/auth/refresh")) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    return res.json();
  } catch (error) {
    return error;
  }
};


export const Base_URL="https://prime-be-stg.parilabs.xyz";

